import React from "react";

export const PageNotFound = () => {
    return (
        <>
            <h1>Page Not Found.</h1>
            <p>Err: 404. This page doesn't exist!</p>
        </>
    );
}